/**
 * Shared helpers for the Company Registration detail sub-components.
 * Extracted from CompanyRegistrationDetailPage.jsx during the iter-238
 * refactor (Feb 2026) to keep the main page under 250 lines.
 */
import axios from 'axios';
import {
  Clock, CheckCircle2, PlayCircle, Wallet, Package, Percent, Send, Lock,
} from 'lucide-react';

export const API = process.env.REACT_APP_BACKEND_URL;

export const authHeader = () => {
  const token = sessionStorage.getItem('admin_token') || localStorage.getItem('admin_token');
  return { Authorization: 'Bearer ' + token };
};

// Read a File -> data URL (for receipts + license PDFs)
export const fileToDataUrl = (f) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(r.result);
  r.onerror = reject;
  r.readAsDataURL(f);
});

// iter-221 — Ship a receipt to the backend for Gemini OCR. Returns the raw
// AI response `{ is_receipt, amount, reference, currency, date, reject_reason }`
// or throws. Callers show the toast + gate their save button on the result.
// iter-225 (Feb 2026) — added `receiptType` so commission fees can pass
// "commission" and the backend switches to a lenient prompt that also
// accepts tax invoices (which is what CLOUDGM actually issues to RAKEZ).
export const extractReceipt = async (dataUrl, mime, expected, receiptType) => {
  const res = await axios.post(
    API + '/api/admin/company-registrations/extract-receipt',
    {
      file_base64: dataUrl,
      mime,
      expected_amount: expected,
      receipt_type: receiptType || null,
    },
    { headers: authHeader() },
  );
  return res.data?.data || {};
};

// iter-230 (Feb 2026) — Predefined lifecycle for a company-registration.
// Mirrors the AssignedTaskDetailPage.STAGE_CONFIG design 1:1: numbered
// rows, per-stage icon, sequential lock (previous must be done), and a
// per-row "Done / Pending" checkbox on the right.
export const LIFECYCLE_STAGES = [
  { key: 'under_review',          ar: 'قيد المراجعة',                en: 'Under review',            Icon: Clock,          color: '#eab308' },
  { key: 'approved',              ar: 'تمت الموافقة',                en: 'Approved',                Icon: CheckCircle2,   color: '#22c55e' },
  { key: 'in_progress',           ar: 'قيد التنفيذ',                 en: 'In progress',             Icon: PlayCircle,     color: '#3b82f6' },
  { key: 'fees_collection',       ar: 'تحصيل الرسوم',                 en: 'Fee Collection',          Icon: Wallet,         color: '#f59e0b' },
  { key: 'completed',             ar: 'تم الإنجاز',                   en: 'Completed',               Icon: Package,        color: '#10b981' },
  { key: 'commission_collection', ar: 'تحصيل العمولة',                en: 'Commission collection',   Icon: Percent,        color: '#8b5cf6' },
  { key: 'commission_sent',       ar: 'تم إرسال العمولة',             en: 'Commission sent',         Icon: Send,           color: '#d946ef' },
  { key: 'closed',                ar: 'تم الانتهاء وإغلاق الطلب',     en: 'Completed & Closed',      Icon: Lock,           color: '#059669' },
];
